import { ReactNode } from 'react';
import { Text } from '../../../Atoms/Text';
import { INPUT_STYLE } from '../../../../utils/styleHelpers';

export const DetailRow = ({ testId, label, children }: { testId: string; label: string; children: ReactNode }) => (
  <div
    className="flex mb-8"
    data-testid={testId}>
    <Text
      className="font-sans text-grey-4 w-3/5"
      size="sm14">
      {label}
    </Text>
    {children}
  </div>
);

interface TextInputRowProps<F extends string> {
  field: F;
  label: string;
  inputId: string;
  dataCy: string;
  value: string;
  onChange: (field: F, value: string) => void;
}

export const TextInputRow = <F extends string>({
  field,
  label,
  inputId,
  dataCy,
  value,
  onChange
}: TextInputRowProps<F>) => (
  <DetailRow
    testId={`detail-row-${field}`}
    label={label}>
    <div className="w-full">
      <input
        onChange={(e) => onChange(field, e?.target?.value)}
        type="text"
        id={inputId}
        data-cy={dataCy}
        name={field}
        aria-label={field}
        className={INPUT_STYLE}
        value={value}
      />
    </div>
  </DetailRow>
);
